import * as React from 'react';
import AddinEntryButton from './AddinEntryButton';
import { Addin } from 'owa-addins-store';

const styles = require('./AddinEntryButtonListView.scss');

export interface AddinEntryButtonListViewProps {
    hostItemIndex: string;
    addins: Addin[];
}

export default class AddinEntryButtonListView extends React.Component<
    AddinEntryButtonListViewProps,
    any
> {
    render() {
        const listViewItems: JSX.Element[] = [];
        for (const addin of this.props.addins) {
            listViewItems.push(
                <AddinEntryButton
                    hostItemIndex={this.props.hostItemIndex}
                    addin={addin}
                    key={addin.Id}
                />
            );
        }
        return <div className={styles.listViewContainer}>{listViewItems}</div>;
    }
}
